import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { runningPath } from '../utils/paths';
import { SITE_APPS, SITE_NAME } from '../config/siteBranding';
import { RUNNING_LANDING_IMAGES } from '../config/runningLandingAssets';
import './RunningLanding.css';

const RunningLanding = () => {
  const { isAuthenticated, isAdmin, isClubCreator } = useAuth();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const canRegisterClub = isAdmin() || isClubCreator();

  return (
    <div
      className={`running-landing${ready ? ' is-ready' : ''}`}
      aria-label={`${SITE_APPS.running.name} home`}
    >
      <div
        className="running-landing__photo running-landing__photo--trail"
        style={{ backgroundImage: `url(${RUNNING_LANDING_IMAGES.trailBackground})` }}
        aria-hidden="true"
      />
      <div
        className="running-landing__photo running-landing__photo--pack"
        style={{ backgroundImage: `url(${RUNNING_LANDING_IMAGES.packBackground})` }}
        aria-hidden="true"
      />
      <div className="running-landing__gradient" aria-hidden="true" />
      <div className="running-landing__grain" aria-hidden="true" />

      <div className="running-landing__card">
        <p className="running-landing__eyebrow">{SITE_NAME}</p>
        <h1>{SITE_APPS.running.name}</h1>
        <p className="running-landing__tagline">
          Publish routes, set the meet-up, vote availability, and share the run with your club.
        </p>

        <ul className="running-landing__features">
          <li>Published tracks &amp; routes</li>
          <li>Gathering spot &amp; timing</li>
          <li>Availability voting</li>
          <li>Team share links &amp; photos</li>
        </ul>

        <div className="running-landing__actions">
          <Link to={runningPath('/clubs/list')} className="btn btn-primary">
            Browse running clubs
          </Link>
          {isAuthenticated && canRegisterClub && (
            <Link to={runningPath('/clubs/register')} className="btn btn-secondary">
              Register a club
            </Link>
          )}
          {isAuthenticated && (
            <Link to={runningPath('/clubs/mine')} className="btn btn-secondary">
              My clubs
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default RunningLanding;
